import BaseService from "@/services/BaseService";

export default class BenefitService extends BaseService {
  constructor() {
    super('odoo/benefit/');
  }

  findAll() {
    return this.http.get(this._serviceName);
  }
}
